/**
 * @class Oskari.nba.bundle.nba-registers.NbaRegistersBundleInstance
 */
Oskari.clazz.define('Oskari.nba.bundle.nba-registers.NbaRegistersBundleInstance',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  // Best practice is to initialize instance variables here.
  //this.myVar = undefined;
}, {
  /**
   * @static
   * @property __name
   */
  __name: 'nba-registers',
  /**
   * Module protocol method
   *
   * @method getName
   */
  getName: function getName() {
    return this.__name;
  },
  eventHandlers: {},
  /**
   * DefaultExtension method for doing stuff after the bundle has started.
   *
   * @method afterStart
   */
  afterStart: function afterStart(sandbox) {
    //var conf = this.conf;

    //Create the search service
    this.searchService = Oskari.clazz.create('Oskari.nba.bundle.nba-registers.service.RegistersSearchService', this);

    //Create the search tab
    this.tab = Oskari.clazz.create('Oskari.nba.bundle.nba-registers.view.RegistersSearchTab', this);
    this.tab.requestToAddTab();
    var sb = Oskari.getSandbox();
  },
  getSearchService: function getSearchService() {
    return this.searchService;
  }
}, {
  "extend": ["Oskari.userinterface.extension.DefaultExtension"]
});